module.exports = "ul {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    color: #fff;\r\n}\r\n\r\nul span.info_topbar {\r\n    margin-top: 20px;\r\n}\r\n\r\n.txt_info_topbar {\r\n    white-space: nowrap;\r\n    width: 100%;\r\n}\r\n\r\n@media screen and (max-width: 799px) and (orientation: portrait) {\r\n    .info_topbar {\r\n        display: none;\r\n    }\r\n}\r\n\r\n:host {\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/top-bar/top-bar.component.css
// module id = ./src/app/components/top-bar/top-bar.component.css
// module chunks = main